import React from 'react';
import PropTypes from 'prop-types';
import './Tag.css';

/**
 * Unified Tag — sharp corners (no pills). Covers status / role / cohort variants.
 */
export function Tag({
  children,
  variant = 'default',
  density = 'comfortable',
  className = '',
  ...props
}) {
  return (
    <span
      className={[
        'onyx-tag',
        `onyx-tag--${variant}`,
        density !== 'comfortable' ? `onyx-tag--${density}` : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-testid="onyx-tag"
      data-density={density}
      {...props}
    >
      {children}
    </span>
  );
}

Tag.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    'default',
    'success',
    'warning',
    'error',
    'info',
    'muted',
    'intensity-0',
    'intensity-1',
    'intensity-2',
    'intensity-3',
    'intensity-4',
    'intensity-5',
  ]),
  density: PropTypes.oneOf(['comfortable', 'compact']),
  className: PropTypes.string,
};

export default Tag;
